/* eslint-disable no-unused-expressions */
if (typeof window !== 'undefined') {
    import("mediaelement");
    import('mediaelement/build/mediaelementplayer.min.css');
}